import GetInstaData from './getInstaData';

/* this is a test code */

// GetInstaData.getTopPosts('트와이스')
//   .then((res) => {
//     console.log(res);
//     console.log('All tasks are done!');
//   });

// GetInstaData.getRecentPosts('트와이스')
//   .then((res) => {
//     console.log(res);
//     console.log('All tasks are done!');
//   });

export default GetInstaData;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/